import React, { useState } from 'react'
// import useNextComments from 'hooks/use-next-comments'
import useIntersectionObserver from 'hooks/use-intersection-observer'
import { useComments, useCommentsKey } from 'querys/comments'
import useSession from 'querys/session'
import { useQueryClient } from 'react-query'
import { getNextCommentsService } from 'services/comment'
import CommentDetail from './comment-detail'

function CommentList() {
  const { data, isLoading } = useComments()
  const { results: comments } = data ?? { results: [] }
  const [loading, setLoading] = useState()
  const { token } = useSession()
  const queryClient = useQueryClient()
  const COMMENT_KEY = useCommentsKey()

  const fetchNextComments = async () => {
    const { next, count } = queryClient.getQueryData(COMMENT_KEY) || {}
    if (comments?.length < count && next) {
      setLoading(true)
      const nextComments = await getNextCommentsService({ next, token })
      queryClient.setQueryData(
        COMMENT_KEY,
        (allComments) => {
          const newComments = nextComments.results
          return ({ ...nextComments, results: allComments.results.concat(newComments) })
        },
      )
      setLoading(false)
    }
  }

  const { ref: lastComment } = useIntersectionObserver({
    onIntersect: () => fetchNextComments(),
    rootMargin: '0px 0px 400px 0px',
  })

  return (
    <>
      {
        comments?.map(({ uuid }, idx) => (
          <CommentDetail
            key={uuid}
            commentIdx={idx}
            uuid={uuid}
          />
        ))
      }
      <div className="comment-intersecting" ref={lastComment} />
      {(loading || isLoading) && <div>C A R G A N D O....</div>}
    </>
  )
}

export default CommentList
